export default __webpack_public_path__ + "static/media/ic-crops-zucchini.4e3b4c56.svg";